<template>
  <div
      :class="[
      'd-flex h-100 flex-column gmb-control-column',
      { 'gmb-control-column--no-max-width': noMaxWidth },
    ]"
  >
    <div class="d-flex flex-grow-1 h-0 flex-column">
      <slot/>
    </div>

    <div
        v-if="hasControls"
        class="d-flex border-top pt-3 flex-column gmb-control-column__controls"
    >
      <div class="d-flex mx-0 container-xl px-0 flex-row">
        <slot name="controls"/>
      </div>
    </div>
  </div>
</template>

<script>
import {hasEnrichedSlot} from "@/helpers.js";

export default {
  name: "GmbControlColumn",

  components: {},

  props: {
    noMaxWidth: Boolean,
  },

  data() {
    return {};
  },

  computed: {
    hasControls() {
      return hasEnrichedSlot(this, "controls");
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/dimensions";
@import "@/sass/bootstrap-overloads/colors";
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/utilities/spacing";
@import "@/sass/settings/colors";

/* =========================================================================
 * CONTROL COLUMN
 * ========================================================================= */

.gmb-control-column {
  &__controls {
    padding-left: calc(#{$gmb-offset-3} / 2 + #{$spacer} * 0.5);
    // padding-right: calc(#{$gmb-offset-3} / 2 + #{$spacer} * 0.5);
  }
}
</style>
